import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AppButton } from "@/components/ui/primitives";

export const NotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <main className="app-page grid min-h-[70vh] place-items-center px-4 py-12">
      <section className="app-panel-raised w-full max-w-2xl p-6 text-center sm:p-10" role="status" aria-labelledby="not-found-title" aria-describedby="not-found-description">
        <p className="text-[length:var(--ds-type-overline-size)] font-medium uppercase tracking-[var(--ds-type-overline-tracking)] text-[var(--app-text-secondary)]">404</p>
        <h1 id="not-found-title" className="mt-4 font-[var(--ds-font-display)] text-[length:var(--ds-type-display-lg-size)] leading-[var(--ds-type-display-lg-line)] font-normal tracking-[var(--ds-type-display-lg-tracking)] text-[var(--app-text)]">
          {t("router.notFoundTitle", { defaultValue: "Route not found" })}
        </h1>
        <p id="not-found-description" className="mx-auto mt-5 max-w-md text-base leading-6 text-[var(--app-text-secondary)]">
          {t("router.notFoundBody", {
            defaultValue: "If you landed here, the path does not match any route defined in router.",
          })}
        </p>
        <AppButton type="button" tone="primary" className="mt-7" onClick={() => navigate({ to: "/dashboard", replace: true })}>
          {t("common.actions.backHome", { defaultValue: "Back to dashboard" })}
        </AppButton>
      </section>
    </main>
  );
};
